import type {AnchorStoryblok} from '~/storyblok/types';
import type {ComponentObject} from '~/types/storyblok';

export function findAnchorComponents(obj: ComponentObject | Record<string, any>, properties: string[]): AnchorStoryblok[] {
	return properties.reduce((anchors: AnchorStoryblok[], property) => {
		const objArray = obj[property];

		if (Array.isArray(objArray)) {
			return [...anchors, ...objArray.reduce((arrAnchors: AnchorStoryblok[], item: ComponentObject) => {
				if (item.component === 'Anchor') {
					return [...arrAnchors, item as AnchorStoryblok];
				} else {
					return [...arrAnchors, ...findAnchorComponents(item, properties)];
				}
			}, [])];
		} else if (objArray && typeof objArray === 'object') {
			return [...anchors, ...findAnchorComponents(objArray, properties)];
		}

		return anchors;
	}, []);
};
